"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var meta_condition_1 = require("./meta-condition");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var lodash_1 = require("lodash");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var ConditionItemComponent = /** @class */ (function () {
    function ConditionItemComponent(classifierService) {
        this.classifierService = classifierService;
        this.conditionItemChange = new core_1.EventEmitter();
        this.ConditionType = meta_condition_1.ConditionType;
        this.MetaFieldType = idm_kb_service_client_js_1.MetaFieldType;
        this._conditionTypes = [];
        this._valueOptions = [];
        this._isCustomValue = false;
        this._classifierItems = [];
        this._selectedClassifiers = [];
        this._subscriptions = [];
    }
    ConditionItemComponent.prototype.ngOnInit = function () {
        this.initItem();
    };
    ConditionItemComponent.prototype.ngOnDestroy = function () {
        this._subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    Object.defineProperty(ConditionItemComponent.prototype, "conditionTypes", {
        get: function () {
            return this._conditionTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionItemComponent.prototype, "selectedType", {
        get: function () {
            return this._selectedType;
        },
        set: function (value) {
            this._selectedType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionItemComponent.prototype, "valueOptions", {
        get: function () {
            return this._valueOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionItemComponent.prototype, "selectedField", {
        get: function () {
            return this._selectedField;
        },
        set: function (selectedField) {
            this._selectedField = selectedField;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionItemComponent.prototype, "selectedValueOption", {
        get: function () {
            return this._selectedValueOption;
        },
        set: function (value) {
            this._selectedValueOption = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionItemComponent.prototype, "isCustomValue", {
        get: function () {
            return this._isCustomValue;
        },
        enumerable: true,
        configurable: true
    });
    ConditionItemComponent.prototype.selectField = function (field) {
        var _this = this;
        this.selectedField = field;
        this.conditionItem.field = field;
        this._conditionTypes = meta_condition_1.conditionsByFieldType(field);
        this.selectType(this._conditionTypes[0]);
        if (!lodash_1.isNil(field) &&
            (field.getType() === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER ||
                field.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT)) {
            this._subscriptions.push(this.loadClassifiers(field.getCompoundCategorySystemName()).subscribe(function (classifiers) { return (_this._classifierItems = classifiers); }, console.error));
        }
        this.conditionItemChange.emit();
    };
    ConditionItemComponent.prototype.selectValueOption = function (option) {
        this._selectedValueOption = option;
        this._isCustomValue = lodash_1.isNil(option) || lodash_1.isNil(option.metaField);
        if (!this._isCustomValue) {
            this.conditionItem.value = "entity." + option.metaField.getSystemName();
        }
        else {
            this.conditionItem.value = undefined;
        }
        this.conditionItemChange.emit();
    };
    ConditionItemComponent.prototype.selectType = function (type) {
        this.selectedType = type;
        this.conditionItem.conditionType = type;
        if (type === meta_condition_1.ConditionType.BETWEEN ||
            type === meta_condition_1.ConditionType.NOT_BETWEEN) {
            this.conditionItem.value = new Array(2).fill(undefined);
        }
        else if (type === meta_condition_1.ConditionType.IS_SPECIFIED ||
            type === meta_condition_1.ConditionType.IS_NOT_SPECIFIED) {
            this.conditionItemChange.emit();
        }
        else {
            this.generateValueOptions();
        }
        this.reset();
    };
    ConditionItemComponent.prototype.customValueChange = function (value) {
        if (!lodash_1.isNil(this.conditionItem.field) &&
            (this.conditionItem.field.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER ||
                this.conditionItem.field.getType() === idm_kb_service_client_js_1.MetaFieldType.DECIMAL ||
                this.conditionItem.field.getType() ===
                    idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL)) {
            this.conditionItem.value = Number(value);
        }
        else {
            this.conditionItem.value = value;
        }
        this.conditionItemChange.emit();
    };
    ConditionItemComponent.prototype.betweenValueChangeTo = function (value) {
        this.conditionItem.value[0] = Number(value);
    };
    ConditionItemComponent.prototype.betweenValueChangeFrom = function (value) {
        this.conditionItem.value[1] = Number(value);
        this.conditionItemChange.emit();
    };
    Object.defineProperty(ConditionItemComponent.prototype, "selectedClassifiers", {
        get: function () {
            return this._selectedClassifiers;
        },
        set: function (value) {
            this._selectedClassifiers = value;
            this.conditionItem.value = value;
            this.conditionItemChange.emit();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConditionItemComponent.prototype, "classifierItems", {
        get: function () {
            return this._classifierItems;
        },
        enumerable: true,
        configurable: true
    });
    ConditionItemComponent.prototype.initItem = function () {
        var _this = this;
        this.selectedField = this.conditionItem.field;
        this._conditionTypes = meta_condition_1.conditionsByFieldType(this.selectedField);
        this.selectedType = this.conditionItem.conditionType;
        if (!lodash_1.isNil(this.selectedField) && !lodash_1.isNil(this.selectedType)) {
            switch (this._selectedType) {
                case meta_condition_1.ConditionType.IN:
                case meta_condition_1.ConditionType.NOT_IN:
                    this._selectedClassifiers = this.conditionItem
                        .value;
                    this._subscriptions.push(this.loadClassifiers(this.selectedField.getCompoundCategorySystemName()).subscribe(function (classifiers) {
                        return (_this._classifierItems = classifiers);
                    }, console.error));
                    break;
                case meta_condition_1.ConditionType.EQUAL:
                case meta_condition_1.ConditionType.IS:
                case meta_condition_1.ConditionType.NOT_IS:
                case meta_condition_1.ConditionType.NOT_EQUAL:
                case meta_condition_1.ConditionType.LESS_THAN:
                case meta_condition_1.ConditionType.LESS_THAN_OR_EQUAL:
                case meta_condition_1.ConditionType.GREATER_THAN:
                case meta_condition_1.ConditionType.GREATER_THAN_OR_EQUAL:
                case meta_condition_1.ConditionType.CONTAINS:
                case meta_condition_1.ConditionType.NOT_CONTAINS:
                    if (this._selectedField.getType() ===
                        idm_kb_service_client_js_1.MetaFieldType.DATE_TIME &&
                        !lodash_1.isNil(this.conditionItem.value) &&
                        !this.isFieldValue()) {
                        this.conditionItem.value = new Date(this.conditionItem.value);
                    }
                    this.generateValueOptions();
                    if (this.isFieldValue()) {
                        this.handleFieldValue();
                    }
                    else {
                        this.selectedValueOption = this.valueOptions.find(function (op) { return op.group === ValueOptionType.Custom; });
                        this._isCustomValue = true;
                    }
            }
        }
    };
    ConditionItemComponent.prototype.isFieldValue = function () {
        if (this.conditionItem.value instanceof idm_kb_service_client_js_1.MetaField) {
            return true;
        }
        return (lodash_1.isString(this.conditionItem.value) &&
            lodash_1.startsWith(this.conditionItem.value, 'entity.'));
    };
    ConditionItemComponent.prototype.handleFieldValue = function () {
        if (this.conditionItem.value instanceof idm_kb_service_client_js_1.MetaField) {
            var metaFieldValue_1 = this.conditionItem.value;
            this.selectedValueOption = this.valueOptions.find(function (op) {
                return op.metaField.getSystemName() ===
                    metaFieldValue_1.getSystemName();
            });
        }
        else if (lodash_1.isString(this.conditionItem.value) &&
            lodash_1.startsWith(this.conditionItem.value, 'entity.')) {
            var systemName_1 = this.conditionItem.value.split('.')[1];
            this.selectedValueOption = this.valueOptions.find(function (op) { return op.metaField.getSystemName() === systemName_1; });
        }
    };
    ConditionItemComponent.prototype.reset = function () {
        this._selectedValueOption = undefined;
        this._isCustomValue = false;
        this._selectedClassifiers = [];
    };
    ConditionItemComponent.prototype.loadClassifiers = function (systemName) {
        return this.classifierService.loadClassifiersView(systemName);
    };
    ConditionItemComponent.prototype.generateValueOptions = function () {
        var _this = this;
        var _a;
        this._valueOptions = [];
        (_a = this._valueOptions).push.apply(_a, this.metaFields
            .filter(function (field) {
            return !lodash_1.isNil(_this._selectedField) &&
                field.getType() === _this._selectedField.getType();
        })
            .map(function (field) {
            return {
                name: field
                    .getDisplayNameMultilingual()
                    .getValue(_this.currentLanguage.getId()),
                metaField: field,
                group: ValueOptionType.Field,
            };
        }));
        this._valueOptions.push({
            name: 'Value',
            metaField: undefined,
            group: ValueOptionType.Custom,
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", meta_condition_1.ConditionItem)
    ], ConditionItemComponent.prototype, "conditionItem", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], ConditionItemComponent.prototype, "metaFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.Language)
    ], ConditionItemComponent.prototype, "currentLanguage", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], ConditionItemComponent.prototype, "conditionItemChange", void 0);
    ConditionItemComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'condition-item',
            template: require('./condition-item.component.html'),
            encapsulation: core_1.ViewEncapsulation.None,
        }),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService])
    ], ConditionItemComponent);
    return ConditionItemComponent;
}());
exports.ConditionItemComponent = ConditionItemComponent;
var ValueOptionType;
(function (ValueOptionType) {
    ValueOptionType["Field"] = "Field";
    ValueOptionType["Custom"] = "Custom";
})(ValueOptionType || (ValueOptionType = {}));
//# sourceMappingURL=condition-item.component.js.map